import { Injectable,SecurityContext } from '@angular/core';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { GuestService } from '../../services/guest.service';


@Injectable({
  providedIn: 'root'
})

export class DynamicFormService {
  selectedCountryCode: string;
  selectedRadioOption: number;
  requiredPhoneNumberLength$: number;
  HTMLPattern = "^[^<>]+$"
  selectedCountryId: number;
  countriesList = [];
  ValidateGuestPhoneNumber: boolean = true;
  constructor(private domSanitizer: DomSanitizer,private guestService: GuestService) { }

  onInputChange(event, backspace) {
    let newVal = event ? event.replace(/\D/g, '') : '';
    //let newVal =  backspace? event:event.replace(/\D/g, '');
    let stringCount;
    if (newVal) {
      if(backspace){
        newVal = newVal.substring(0, newVal.length);
      }
      else{
        stringCount = this.countriesList.find(country => country.Id == (this.guestService.selectedCountryId || this.selectedCountryId))?.PhoneNumberLength;
        let phoneNumberFormatArray = (this.countriesList.find(country => country.Id == (this.guestService.selectedCountryId || this.selectedCountryId))?.PhoneNumberPattern.split(', '))
        if(phoneNumberFormatArray && phoneNumberFormatArray.length){
          newVal = newVal.replace(this.getFormat(phoneNumberFormatArray[0]), this.getFormat(phoneNumberFormatArray[1]));
        }
   //     eval(this.cs.settings.value.Countries.find(country => country.Id == (this.selectedCountryId))?.PhoneNumberPattern.split(', ')[0]), eval(this.cs.settings.value.Countries.find(country => country.Id == this.selectedCountryId)?.PhoneNumberPattern.split(', ')[1])
       }
      }

      if (this.ValidateGuestPhoneNumber) {
        this.requiredPhoneNumberLength$ = stringCount;
      } else {
        this.requiredPhoneNumberLength$ = null;
      }

    return newVal;
  }

  getFormat(format){
    return new Function( 'return (' + format + ')' )()
  }
  inputvalidation(value){
    let secureText = this.domSanitizer.sanitize(SecurityContext.HTML, value);
    if(secureText == value) {
      return false;
    }else{
      return true;
    }
  }
}
